import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
    container: {
        padding: "0 4px",
        backgroundColor: "#E2E6EE",
        borderRadius: "0 4px 4px 4px",
    },
    titleBox: {
        display: "inline",
        padding: "6px 8px",
        backgroundColor: "#E2E6EE",
        borderRadius: "4px 4px 0 0",
    },
    statusChip: {
        border: "none",
        cursor: "pointer",
        "& .MuiChip-iconColorPrimary": {
            color: theme.palette.secondary.main
        }
    },
    rotateIcon: {
        animation: "$spin 3s linear infinite"
    },
    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(360deg)"
        }
    },
    card: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px",
        margin: "8px 4px",
        cursor: "pointer",
        boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
        transition: theme.transitions.create("transform", {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.short,
        }),
        "&:hover": {
            transform: "scale(1.015)"
        }
    }
}));